import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { CategoriesService } from '../../services/categories.service';
import { NgxSelectOption } from 'ngx-select-ex';
import { SaveFormService } from '../../services/save-form.service';
import { EnumDescription } from '../../helpers/enum-description.helper';
import { TreeviewItem } from 'ngx-treeview';
import { Subscription } from 'rxjs';
import { AdminQuestion, QuestionType, Category } from '../../models/questions';

@Component({
  selector: 'app-question-forms-builder',
  templateUrl: './question-forms-builder.component.html',
  styleUrls: ['./question-forms-builder.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionFormsBuilderComponent implements OnInit, OnDestroy {
  @Input() question: AdminQuestion = { answerType: QuestionType.Text };
  @Input() isAddForm: boolean;
  @Input() selectedCategoryId: number;
  @Output() onCancelForm = new EventEmitter();
  @Output() onSaveAddEditForm = new EventEmitter<AdminQuestion>();

  treeviewSelectable: Array<TreeviewItem>;
  questionType: any = QuestionType;
  categories: Array<Category>;
  questionsTypeItems: Array<NgxSelectOption>;
  questionTypesSelectControl = new FormControl();
  isOnSaving: boolean = false;

  private subs: Subscription[] = [];

  constructor(
    private categoriesService: CategoriesService,
    private saveFormService: SaveFormService
  ) {}

  ngOnInit() {
    const questionType = this.question.answerType
      ? this.question.answerType
      : QuestionType.Text;
    this.setType(questionType);
    this.subscribeToCloseAddEdit();
    this.saveFormService.formValueChanged$.subscribe(
      (x) => (this.isOnSaving = !x)
    );
    this.categoriesService.getAll().subscribe((c) => {
      this.categories = c;
      this.treeviewSelectable = this.mapCategoriesToNgSelect(this.categories);
      this.getDefaultCategory(this.treeviewSelectable);
      this.questionsTypeItems = this.mapQuestionTypesToNgSelect(
        this.questionType
      );
    });
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => {
      sub?.unsubscribe();
    });
    this.isOnSaving = false;
  }

  addButtonClicked(isColumn: boolean) {
    this.saveFormService.addButtonClicked(isColumn);
  }

  saveButtonClicked() {
    this.isOnSaving = true;
    this.saveFormService.saveButtonClicked(this.question, this.isAddForm);
  }

  isLeftAddButtonEnable(): boolean {
    return (
      this.question.answerType &&
      !(
        this.question.answerType === QuestionType.Number ||
        this.question.answerType === +QuestionType.Text
      )
    );
  }

  isRightAddButtonEnable(): boolean {
    return (
      this.isLeftAddButtonEnable() &&
      (this.question.answerType === QuestionType.MatrixCheckbox ||
        this.question.answerType === QuestionType.MatrixRadiobutton)
    );
  }

  cancelAddEditForm() {
    this.onCancelForm.emit();
  }

  getSelectedItem(data: Array<TreeviewItem>) {
    this.question.categoryIds = data.map((x) => x.value);
  }

  private setType(questionType: QuestionType) {
    this.questionTypesSelectControl.setValue(questionType);
    const sub = this.questionTypesSelectControl.valueChanges.subscribe(
      (value) => {
        this.question.answerType = value;
        this.question.answers = [];
      }
    );
    this.subs.push(sub);
  }

  private mapCategoriesToNgSelect(
    categories: Array<Category>
  ): Array<TreeviewItem> {
    return categories.map((x) =>
      Object.assign(
        new TreeviewItem({
          value: x.id,
          text: !!x.name ? x.name : '',
          checked: this.question.categoryIds
            ? this.question.categoryIds.some((q) => q === x.id)
            : false,
          children: [],
          collapsed: true,
        })
      )
    );
  }

  private mapQuestionTypesToNgSelect(
    questionTypes: QuestionType
  ): Array<NgxSelectOption> {
    const enumKeys = Object.keys(QuestionType).filter(
      (k) => typeof QuestionType[k as any] === 'number'
    );
    return enumKeys.map((x) =>
      Object.assign({
        id: QuestionType[x],
        text: EnumDescription.GetDescription(QuestionType, QuestionType[x]),
      })
    );
  }

  private getDefaultCategory(treeviewCategories: Array<TreeviewItem>) {
    if (this.question.categoryIds && this.question.categoryIds.length > 0) {
      return;
    } else {
      if (
        !!treeviewCategories.find((x) => x.value === this.selectedCategoryId)
      ) {
        treeviewCategories.find(
          (x) => x.value === this.selectedCategoryId
        ).checked = true;
      }
      this.question.categoryIds = [this.selectedCategoryId];
    }
  }

  private subscribeToCloseAddEdit() {
    const sub = this.saveFormService.formClosed$.subscribe((question) => {
      this.onSaveAddEditForm.emit(question);
    });
    this.subs.push(sub);
  }
}
